import { Link } from "react-router";

import { Button } from "@/components/ui/button";

interface NoModulesProps {
  title?: string;
  message?: React.ReactNode;
  backToRoute?: string;
  backToLabel?: string;
}

export default function NoModules({
  title = "Sem módulos ativos",
  message = (
    <>
      Nenhum módulo liberado para o usuário.
      <br />
      Antes de acessar, entre em contato com o administrador da conta para
      liberar seu acesso.
    </>
  ),
  backToRoute,
  backToLabel = "Voltar para o Dashboard",
}: NoModulesProps) {
  return (
    <div className="flex items-center justify-center min-h-[60vh] w-full">
      <div className="text-center max-w-xl px-4">
        <h1 className="text-2xl font-bold">{title}</h1>
        <p className="mt-3 text-muted-foreground">{message}</p>
        {backToRoute && (
          <Button asChild className="mt-6">
            <Link to={backToRoute}>{backToLabel}</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
